/**
 * Types for streaming agent SSE events based on muppeteer's response format
 */

export enum StreamEventType {
  TOOL_START = 'tool_start_event',
  TOOL_EVENT = 'tool_event',
  AI_EVENT = 'ai_event',
  INTERRUPT_EVENT = 'interrupt_event',
  DONE = 'done',
  ERROR = 'error',
}

export enum ToolName {
  WRITE_TODOS = 'write_todos',
  TASK = 'task',
  OTHER = 'other',
  // Add other tool names as needed
}

export interface TodoItem {
  content: string
  status: 'pending' | 'in_progress' | 'completed'
}

export interface WriteTodosToolCall {
  name: ToolName.WRITE_TODOS
  id: string
  args: {
    todos: TodoItem[]
  }
}

export interface TaskToolCall {
  name: ToolName.TASK
  id: string
  args: {
    description: string
    subagent_type: string
  }
}

export interface UnknownToolCall {
  name: ToolName.OTHER
  id: string
}

export type ToolCall = WriteTodosToolCall | TaskToolCall | UnknownToolCall

export interface ToolStartEvent {
  tool_calls: ToolCall[]
}

export interface ToolEvent {
  markdown: string
}

export interface AIEvent {
  markdown: string
}

export interface StreamEvent {
  type: StreamEventType
  data: ToolStartEvent | ToolEvent | AIEvent | string
}

export interface StreamMessage {
  id: string
  timestamp: Date
  eventType: StreamEventType
  content?: string
  toolCalls?: ToolCall[]
}
